var _defs, _circle, _path, _path2, _path3, _rect, _rect2, _polygon, _line, _line2, _polygon2, _circle2, _circle3, _circle4, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterOfOralImplantology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "implGrad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f17067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f89f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "implGrad2",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ecb488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fccc9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "implGrad3",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f89f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f17067"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 160,
    r: 110,
    fill: "none",
    stroke: "url(#implGrad2)",
    strokeWidth: 8,
    opacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175,70 L260,110 L260,190 Q260,250 175,280 Q90,250 90,190 L90,110 Z",
    fill: "url(#implGrad1)",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175,80 L250,115 L250,188 Q250,242 175,270 Q100,242 100,188 L100,115 Z",
    fill: "none",
    stroke: "url(#implGrad1)",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145,120 Q145,100 175,100 Q205,100 205,120 L205,155 Q205,170 195,175 L195,190 L175,195 L155,190 L155,175 Q145,170 145,155 Z",
    fill: "url(#implGrad3)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 195,
    width: 14,
    height: 10,
    rx: 2,
    fill: "url(#implGrad2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 205,
    width: 10,
    height: 6,
    rx: 1,
    fill: "url(#implGrad2)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "175,225 170,211 180,211",
    fill: "url(#implGrad2)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 168,
    y1: 208,
    x2: 182,
    y2: 208,
    stroke: "url(#implGrad3)",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 169,
    y1: 213,
    x2: 181,
    y2: 213,
    stroke: "url(#implGrad3)",
    strokeWidth: 1.5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "175,78 179,90 192,90 182,98 186,110 175,102 164,110 168,98 158,90 171,90",
    fill: "url(#implGrad3)",
    opacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 160,
    r: 5,
    fill: "url(#implGrad2)",
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 160,
    r: 5,
    fill: "url(#implGrad2)",
    opacity: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 250,
    r: 5,
    fill: "url(#implGrad2)",
    opacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 300,
    width: 150,
    height: 10,
    rx: 4,
    fill: "url(#implGrad2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterOfOralImplantology);
export default __webpack_public_path__ + "static/media/MasterOfOralImplantology.f906031e17c870d56cf9244644e49e85.svg";
export { ForwardRef as ReactComponent };